<template>
    <div class="row">
        <div class="col-12">
            <button class="btn btn-primary float-right" @click="$router.push('/settings/users/roles/create')">{{ $t('create-role') }}</button>
            <h1 class="mb-4">{{ $t('roles') }}</h1>
            
            <Table
                :data="roles"
                :cols="[
                    { key: 'name', heading: 'Name', size: 3, sortable: true, },
                    { key: 'description', heading: 'Description', size: 9, sortable: true },
                ]"
                :filters="filters"
                :loading="loading"
                :submitting="submitting"
                :scrollPaginate="true"
                breakpoint="md"
                @refresh="refresh"
                @selectItem="role => $router.push(`/settings/users/roles/update/${role.id}`)"
            >
                <template v-slot:search>
                    <div class="list-group-item">
                        <SearchBar 
                            :debounce="false" 
                            v-model="localSearch"
                            @input="roles = allRoles.filter(role => role.name.toLowerCase().includes(localSearch.toLowerCase()))"
                        />
                    </div>
                </template>
            </Table>
        </div>
    </div>
</template>

<script>
import Table from "src/components/Table/Table.vue";
import SearchBar from "src/components/Table/SearchBar.vue";

export default {
    async mounted() {
        await this.fetchRoles()
        this.loading = false
    },
    data() {
        return {
            roles: [],
            filters: {
                page: 1, 
                page_size: 20,
            },
            total_count: 0,
            loading: true,
            submitting: false,

            // As we're fetching all roles, we'll use these two vars to filter our local results,
            // instead of making unnecessary API requests
            allRoles: [],
            localSearch: '',
        }
    },
    methods: {
        async fetchRoles() {
            if (this.submitting) return
            this.submitting = true

            try {
                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/roles/all`)

                if (res.status !== 'SUCCESS') return

                this.allRoles = res.roles
                this.roles = res.roles
            } 
            catch (err) {
                this.$log.error.call(this, err)
            } 
            finally {
                this.submitting = false
            }
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters }
            this.fetchRoles()
        },
    },
    components: {
    Table,
    SearchBar
},
}
</script>